import { contactBannerHTML, handleFreeShipping } from '../global'
import { isMobile } from '../base'

export function initStep1() {
    if ($('.id--9').length) {
        step1ContentLoaded()

        document.addEventListener('ShoptetDOMCartContentLoaded', step1ContentLoaded)
    }
}

function step1ContentLoaded() {
    restructureCartLayout()
    addProductCode()
    giftWrapper()
    step1TextChanges()
    handleFreeShipping()
    storeCartImages()
}

function step1TextChanges() {
    $('.discount-coupon .btn').text('Anwenden');
    $('.btn-conversion').text('Versand und Zahlung auswählen');
}

// Přesouvá elementy do nového layoutu
function restructureCartLayout() {
    const priceSidebar = $('.cart-inner .summary .col-md-4')
    const cartTable = $('.cart-table')
    const priceWrapper = $('.price-wrapper')
    const nextStep = $('.next-step')
    const plantTree = $('.planetwe-wrapper-outer')

    priceSidebar.insertAfter(cartTable)

    cartTable.wrap("<div class='col-md-8'></div>")

    if (plantTree.length && cartTable.length) {
        plantTree.insertAfter(cartTable);
    }

    $(`<h4><strong>Inhalt</strong> des Warenkorbs</h4>`).insertBefore(cartTable);
    $(`<h4><strong>Bestellübersicht</strong></h4>`).insertBefore('.price-wrapper');

    $('.row.summary .coupon-input').insertAfter(priceWrapper)
    $('.row.summary .delivery').insertBefore(priceWrapper)

    $(nextStep).after(`
        <div class="cart-banner">
            <div class="cart-banner__item cart">
                Bestellungen an Werktagen bis 14:00 Uhr werden am selben Tag versandt
            </div>
            <div class="cart-banner__item return">
                Rückerstattung innerhalb von 30 Tagen
            </div>
            <div class="cart-banner__item payment">
                Sichere Online-Kartenzahlung
            </div>
        </div>
    `);

    $('.row.summary .delivery-time').prependTo('.cart-banner')
}

// Pokud jsou v košíku dárky vytvoří se pro ně kontejner napozicovaný pod produkty
function giftWrapper() {
    const giftSelectors = [
        { selector: '.free-product-gifts li', class: 'gifts-item-1' },
        { selector: '[data-testid="wrapperOrderGift"]', class: 'gifts-item-2' },
        { selector: '[data-testid="selectGiftWrapper"]', class: 'gifts-item-2' },
    ]

    const hasGifts = giftSelectors.some(({ selector }) => $(selector).length)

    if (hasGifts) {
        $('.row.summary').prepend(`<div class="gift-wrapper"><h2>ZUBEHÖR ZUM PRODUKT</h2></div>`);

        giftSelectors.forEach(({ selector, class: className }) => {
            const gifts = $(selector);
            if (gifts.length) {
                const container = $(`<div class="${className}"></div>`).appendTo('.gift-wrapper');
                processGifts(gifts, container);
            }
        });
    }
}

function addProductCode() {
    const cartData = getShoptetDataLayer('cart');

    $('.p-name .main-link').each(function() {
        const name = $(this);
        const itemId = name.closest('td').find('form.delete-cart-item input[name="itemId"]').val();

        const product = cartData.find(function(p) {
            return p.itemId === itemId;
        });

        if (!product) return;

        const pCode = $('<p class="p-code">').text('Kód: ' + product.code);
        name.after(pCode);
    });
}

function processGifts(gifts, container) {
    gifts.each(function () {
        const gift = $(this)
        const giftName = gift.find('.free-gift-name')

        addGiftLabel(giftName)
        gift.find('.free-gifts-img-hover').remove()

        if (gift.is('li')) {
            gift.appendTo(container)
        } else {
            gift.find('li').each(function () {
                addGiftLabel($(this).find('.free-gift-name'))
            })
            gift.appendTo(container)
        }
    })
}

function addGiftLabel(giftName) {
    // giftName.text(giftName.text()).after(`<span class="product-is-gift">${_t('cart.step1.gift')}</span>`)
}

function storeCartImages() {
    const map = {}
    $('tr[data-micro-sku]').each(function () {
        const sku = $(this).data('micro-sku')
        const $img = $(this).find('.cart-p-image img')
        const src = $img.attr('data-src') || $img.attr('src')
        if (sku && src) map[sku] = src
    })
    localStorage.setItem('cartImageMap', JSON.stringify(map))
}
